export class MenuResp {
  public static frontend(el: HTMLElement, opt: Record<string, never>) {
    const elements = el.querySelectorAll('.sub-menu');
    elements.forEach((subMenu) => {
      if (subMenu.querySelectorAll('a').length > 1) {
        const $icon = document.createElement('i');
        $icon.className = 'fa fa-fw fa-caret-down';
        $icon.addEventListener('click', () => subMenu.classList.toggle('show'));

        const prevDiv = subMenu.parentElement.firstElementChild;
        prevDiv.appendChild($icon);

        const $parent = prevDiv.querySelector('a');
        const hasLink = $parent.getAttribute('href') !== '#';
        $parent.addEventListener('click', (e) => {
          if (!hasLink) {
            e.preventDefault();
            subMenu.classList.toggle('show');
          }
        });
      }
    });
    return {el};
  }
}
